/* eslint-disable max-len */
import { useApolloClient } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import Dots from '../../../components/Loading/Dots';
import { GET_ALL_KAABO_COUPONS } from '../../../graphql/admin_queries';
import Styles from './PartnerCouponsDashboard.module.scss';

type Props = {
  refreshKey?: number;
};

const PartnerCouponsDashboard = ({ refreshKey = 0 }: Props) => {
  const client = useApolloClient();
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [active, setActive] = useState(0);
  const [inactive, setInactive] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const baseVars = {
      limit: 1,
      offset: 0,
      search: null as string | null,
      partnerId: null as string | null,
    };

    (async () => {
      setLoading(true);
      try {
        const [allRes, activeRes, inactiveRes] = await Promise.all([
          client.query({
            query: GET_ALL_KAABO_COUPONS,
            variables: { ...baseVars, status: null },
            fetchPolicy: 'network-only',
          }),
          client.query({
            query: GET_ALL_KAABO_COUPONS,
            variables: { ...baseVars, status: 'active' },
            fetchPolicy: 'network-only',
          }),
          client.query({
            query: GET_ALL_KAABO_COUPONS,
            variables: { ...baseVars, status: 'inactive' },
            fetchPolicy: 'network-only',
          }),
        ]);
        if (cancelled) return;
        setTotal(allRes.data?.getAllCoupons?.data?.count ?? 0);
        setActive(activeRes.data?.getAllCoupons?.data?.count ?? 0);
        setInactive(inactiveRes.data?.getAllCoupons?.data?.count ?? 0);
      } catch {
        if (!cancelled) {
          setTotal(0);
          setActive(0);
          setInactive(0);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [client, refreshKey]);

  const cards = [
    {
      id: 1, title: 'Total coupons', count: total,
    },
    {
      id: 2, title: 'Active coupons', count: active,
    },
    {
      id: 3, title: 'Inactive coupons', count: inactive,
    },
  ];

  return (
    <div className={Styles.wrapper}>
      <div className="row">
        {cards.map((c) => (
          <div key={c.id} className="col-12 col-md-4">
            <div className={Styles.wrapper__container}>
              {loading && (
                <div className={Styles.wrapper__loaderContainer}>
                  <div className={Styles.wrapper__detailsLoader}>
                    <Dots />
                  </div>
                </div>
              )}
              {!loading && (
                <>
                  <div className={Styles.wrapper__title}>{c.title}</div>
                  <div className={Styles.wrapper__count}>{c.count}</div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnerCouponsDashboard;
